export const FETCH_LOGGED_IN_USER_PENDING = 'FETCH_LOGGED_IN_USER_PENDING';
export const FETCH_LOGGED_IN_USER_SUCCESS = 'FETCH_LOGGED_IN_USER_SUCCESS';
export const FETCH_LOGGED_IN_USER_ERROR = 'FETCH_LOGGED_IN_USER_ERROR';
